import { render, staticRenderFns } from "./SidebarItemLink.vue?vue&type=template&id=19fb80c2&"
import script from "./SidebarItemLink.vue?vue&type=script&lang=ts&"
export * from "./SidebarItemLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19fb80c2')) {
      api.createRecord('19fb80c2', component.options)
    } else {
      api.reload('19fb80c2', component.options)
    }
    module.hot.accept("./SidebarItemLink.vue?vue&type=template&id=19fb80c2&", function () {
      api.rerender('19fb80c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/layout/components/Sidebar/SidebarItemLink.vue"
export default component.exports